export default __webpack_public_path__ + "static/media/kems-left.03cda885.svg";